import { AuthError, AuthErrorData } from '@/pages/auth/types';
import { snakeToCamelCase } from '@/utils/caseTransformer';

export function parse({ error }: AuthErrorData): AuthError {
  return snakeToCamelCase(error);
}
